module.exports = __webpack_public_path__ + "img/trophy.80d67f63.png";